import { useCallback, useRef } from 'react';

import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  ButtonGroup,
  Text,
  UseDisclosureReturn,
} from '@frontend/legacy-components';

import { useSwitchGroup } from './hooks/useSwitchGroup';

type ConfirmChangeSiteDialogProps = UseDisclosureReturn & {
  groupBusinessName: string;
  userGroupId: number;
  nextUrl: string;
};

export const ConfirmChangeSiteDialog = ({
  isOpen,
  onClose,
  groupBusinessName,
  nextUrl,
  userGroupId,
}: ConfirmChangeSiteDialogProps) => {
  const cancelRef = useRef<HTMLButtonElement | null>(null);

  const switchGroup = useSwitchGroup();
  const handleSwitch = useCallback(() => {
    switchGroup(userGroupId, nextUrl);
  }, [switchGroup, userGroupId, nextUrl]);

  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={onClose}
      leastDestructiveRef={cancelRef}
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader>Change active site?</AlertDialogHeader>
          <AlertDialogBody>
            <Text>
              Following this link will change your active site to{' '}
              <Text as="span" fontWeight="bold">
                {groupBusinessName}
              </Text>{' '}
              across any open tabs and windows. Any unsaved changes will be
              lost.
            </Text>
          </AlertDialogBody>
          <AlertDialogFooter>
            <ButtonGroup>
              <Button ref={cancelRef} variant="secondary" onClick={onClose}>
                Cancel
              </Button>
              <Button onClick={handleSwitch}>Proceed</Button>
            </ButtonGroup>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
